import SephoraProductsUtils from '@/components/sephora-products/utils';
import RetailProducts from '@/components/retail-products';
import { Colors } from '@/components/retail-products/style';

export default class SephoraProducts extends RetailProducts {
  static get observedAttributes() {
    return ['products'];
  }

  styleProperties = { titleWidth: 275 };

  onConstruct() {
    this.backgroundColor = Colors.backgroundColor;
    SephoraProductsUtils.getProducts().then((products) => {
      this.products = products;
    });
  }

  StepTwoTitle() {
    return `
      ${super.StepTwoTitle()}
      <div class="middle-container">
            <div
                class="middle-image"
                style="
                    background-image: url('${
                      this.isSmall ? this.middleImageMobile : this.middleImage
                    }');
                    ${this.isSmall ? ' background-position: center;' : ''}"
                >
            </div>
        </div>
    `;
  }
}
